import { EnrollmentCharacteristicsInput } from '../../lib/types/models/enrollment-characteristics/enrollment-characteristics-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function updateEnrollmentCharacteristic(
  data: UpdateInput<EnrollmentCharacteristicsInput>
) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.enrollmentCharacteristics.update.url, { id }))
    .patch(rest)
}
